import { Theme, alpha } from '@mui/material';
import { TournamentStatus } from '@okletsplay/core';
import { TOURNAMENT_TILE_MIN_HEIGHT_IN_SPACING } from 'modules/tournaments/constants';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    flexFlow: 'column nowrap',
    height: `min(100%, ${theme.spacing(TOURNAMENT_TILE_MIN_HEIGHT_IN_SPACING)})`,

    position: 'relative',
    flex: 1,
    backgroundColor: theme.palette.background.paper,
    justifyItems: 'center',
    borderRadius: theme.spacing(1.5),
    border: `1px solid ${theme.palette.background.default}`,

    '&:hover': {
      cursor: 'pointer',
      borderColor: theme.palette.primary.light,
    },
  },

  title: {
    fontSize: theme.spacing(3),
    fontFamily: 'Bebas Neue',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: theme.spacing(25),
  },
  header: {
    position: 'relative',
    height: theme.spacing(14),
    backgroundSize: 'cover',
    backgroundBlendMode: 'multiply',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    borderTopLeftRadius: theme.spacing(1.5),
    borderTopRightRadius: theme.spacing(1.5),
    maxHeight: theme.spacing(14),
    minHeight: theme.spacing(14),
    overflow: 'hidden',
    img: {
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    },
  },

  body: {
    padding: theme.spacing(0.5, 2),
  },

  indicatorsContainer: {
    display: 'flex',
    position: 'absolute',
    top: theme.spacing(0.5),
    right: theme.spacing(0.5),
  },

  lockIcon: {
    fontSize: theme.spacing(3.5),
    marginBottom: theme.spacing(0.5),
  },

  footer: {
    alignItems: 'center',
    fontSize: theme.spacing(1.5),
    letterSpacing: '1px',
    padding: theme.spacing(0.5, 2, 1),
  },
  footerItem: {
    display: 'flex',
    alignItems: 'center',
  },
  footerItemContent: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  badgeContainer: {
    bottom: theme.spacing(1),
    left: theme.spacing(2),
    position: 'absolute',
    minHeight: theme.spacing(7.5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  sponsoredBadge: {
    marginTop: 'auto',
  },

  badge: {
    display: 'block',
    width: 'fit-content',
    marginTop: 'auto',
    flexFlow: 'inherit',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderRadius: theme.spacing(2),
    padding: theme.spacing(0.25, 1, 0.25, 0.5),
    backgroundColor: alpha(theme.palette.success.light, 0.9),
  },

  smallIcon: {
    marginTop: theme.spacing(-0.125),
    marginRight: theme.spacing(0.5),
  },

  [TournamentStatus.Pending]: {
    boxShadow: `0 ${theme.spacing(-0.5)} 0 ${theme.spacing(-0.125)} ${
      theme.palette.warning.light
    } inset`,
  },

  [TournamentStatus.Canceled]: { boxShadow: 'none' },
  [TournamentStatus.Failed]: { boxShadow: 'none' },
  [TournamentStatus.Finished]: { boxShadow: 'none' },
  [TournamentStatus.Live]: {
    boxShadow: `0 ${theme.spacing(-0.5)} 0 ${theme.spacing(-0.125)} ${
      theme.palette.success.light
    } inset`,
  },
  [TournamentStatus.Checkin]: {
    boxShadow: `0 ${theme.spacing(-0.5)} 0 ${theme.spacing(-0.125)} ${
      theme.palette.warning.light
    } inset`,
  },
}));
